<div mat-dialog-content class="app-signout-confirmation" id="app-signout-confirmation">
    <div class="fs-16 pt-20 pb-10 text-center fw-500" *ngIf="checkStream && !router.url.includes('/user-dashboard/payment-methods')">{{title}}</div>
    <div class="fs-16 pt-20 pb-10 text-center fw-500" *ngIf="checkStream && router.url.includes('/user-dashboard/payment-methods')">
        <div>{{checkStream.line1}}</div>
        <div>{{checkStream.line2}}</div>
        <div class="fs-12 pt-10">{{checkStream.line3}}</div>
    </div>
    <div class="fs-16 pt-20 pb-10 text-center fw-500" *ngIf="!checkStream && !disConfirm">Are you sure you want to delete ?</div>
    <div class="fs-16 pt-20 pb-10 text-center fw-500" *ngIf="disConfirm">{{disConfirm}}</div>
    <div class="pb-20 text-center" mat-dialog-actions>
        <button mat-flat-button (click)="confirm('yes')" class="flat-primary-button secondary-bg-button mt-10">
            yes
        </button>
        <button mat-flat-button (click)="confirm('no')" class="flat-primary-button secondary-bg-btn1 mt-10">
            No
        </button>
    </div>
</div>